import * as ShadEmpty from '../../core/components/empty'

export function Empty(props: React.ComponentProps<typeof ShadEmpty.Empty>) {
  return <ShadEmpty.Empty {...props} />
}

export function EmptyHeader(props: React.ComponentProps<typeof ShadEmpty.EmptyHeader>) {
  return <ShadEmpty.EmptyHeader {...props} />
}

export function EmptyMedia(props: React.ComponentProps<typeof ShadEmpty.EmptyMedia>) {
  return <ShadEmpty.EmptyMedia {...props} />
}

export function EmptyTitle(props: React.ComponentProps<typeof ShadEmpty.EmptyTitle>) {
  return <ShadEmpty.EmptyTitle {...props} />
}

export function EmptyDescription(props: React.ComponentProps<typeof ShadEmpty.EmptyDescription>) {
  return <ShadEmpty.EmptyDescription {...props} />
}

export function EmptyContent(props: React.ComponentProps<typeof ShadEmpty.EmptyContent>) {
  return <ShadEmpty.EmptyContent {...props} />
}
